import React from 'react'
import { get } from 'lodash'
import { Button, Title, Note, FormButton } from 'components/misc'
import { PaymentInfo } from 'components/forms'
import { LoaderOverlay } from 'components/loaders'
import { SecurityPolicy } from 'components/modals'
import { form } from 'helpers/decorators'
import validate from '../Details/details.validation'

export default form({
  form: 'paymentForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  dataKey: 'initialValues',
  validate
})(({
  awards,
  countries = [],
  employmentStatuses = [],
  errors,
  filteredAwardLevels = [],
  genders = [],
  handleSubmit,
  isEditing,
  isLoading,
  nationalities = [],
  onCancelEdit,
  onEdit,
  onSaveChanges,
  onSubmit,
  participant,
  profileOptions,
  values,
  onPrevLevelChange,
  onSelectBronze,
  questions,
  postalAddress,
  showTitle = true,
  showNationality = true,
  showEmploymentStatus = true,
  showMiddleName = true,
  showAddressLine1 = true,
  showAddressLine2 = true,
  showSecondaryEmail = true,
  showPhone = true,
  showPhoneType = true,
  showCity = true,
  showZipCode = true,
  showRegion = true,
  showCountry = true,
  ...props
}) => {

  let disableContinue = false

  profileOptions.forEach(pq => {

    const answer = questions.find(answer => pq.id === get(answer, 'profileQuestion.id'))

    if(!answer && !pq.isOptional){
        disableContinue = true
    }
  })


  return (
    <LoaderOverlay
      isLoading={isLoading}
      style={{ height: '100%', overflow: 'visible' }}
    >
      <Note
        intlKey="note.review_filled_participant"
        values={{
          name: get(participant, 'firstName') +
            ' ' +
            get(participant, 'lastName')
        }}
      >
        Please review the registration details entered by{' '}
        {get(participant, 'firstName') + ' ' + get(participant, 'lastName')}.
      </Note>
      <Note
        intlKey="note.edit_participant_review"
        className="base-margin--bottom"
      >
        To correct any of this information click on the edit button.
      </Note>
      <Button
        secondary
        intlKey="button.edit_info"
        type="button"
        onClick={onEdit}
        compact
        className="base-margin--bottom"
      >
        Edit info
      </Button>
      <div className="row">
        <div className="col-xs-12 col-sm-5">
          <Title h2 intlKey="wizard.participant_details">
            Participant details
          </Title>

          <PaymentInfo.Details
            participant={participant}
            isEditing={isEditing}
            genders={genders}
            errors={errors}
            countries={countries}
            nationalities={showNationality ? nationalities : undefined}
            employmentStatuses={showEmploymentStatus ? employmentStatuses : undefined}
            postalAddress={postalAddress}
            showTitle={showTitle}
            showMiddleName={showMiddleName}
            showAddressLine1={showAddressLine1}
            showAddressLine2={showAddressLine2}
            showSecondaryEmail={showSecondaryEmail}
            showPhone={showPhone}
            showPhoneType={showPhoneType}
            showCity={showCity}
            showZipCode={showZipCode}
            showRegion={showRegion}
            showCountry={showCountry}
          />
        </div>

        <div className="col-xs-12 col-sm-7">
          <Title h2 intlKey="moduleTitle.level_detail">
            Level detail
          </Title>
          <PaymentInfo.Level
            awards={awards}
            filteredAwardLevels={filteredAwardLevels}
            onPrevLevelChange={onPrevLevelChange}
            onSelectBronze={onSelectBronze}
            isEditing={false}
            errors={errors}
            participant={participant}
            values={values}
          />

          <Title
            h2
            intlKey="moduleTitle.profile_questions"
            className="base-margin--top"
          >
            Profile questions
          </Title>

          <PaymentInfo.Questions
            isEditing={isEditing}
            questions={questions}
            profileOptions={profileOptions}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-7">
          <SecurityPolicy organizationId={get(participant, 'organizationId')} />
        </div>
      </div>
      {!isEditing
        ? <Button
            intlKey="button.continue"
            onClick={onSubmit}
            compact
            className="base-margin--top"
            disabled={disableContinue}
        >
            Continue
          </Button>
        : [
          <FormButton
              {...props}
              intlKey="button.save"
              onClick={handleSubmit(onSaveChanges)}
              compact
              inline
              className="base-margin--top"
          >
              Save
            </FormButton>,
          <Button
              intlKey="button.cancel"
              onClick={onCancelEdit}
              compact
              secondary
              type="button"
              className="base-margin--top"
              style={{ marginLeft: '15px' }}
          >
              Cancel
            </Button>
          ]}
    </LoaderOverlay>
  )
})
